import * as React from "react";
import TextUtils from "../../../utils/TextUtils";
import Toast from "../../helper/Toast";
import IconSmall from "../../../hiberUiKit/src/atoms/Icon/IconSmall";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";

interface Props {
	/**
	 * Route for details.
	 */
	route: string;
}

export default class ActionsColumn extends React.Component<Props> {
	render() {
		return (
			<div className={"c-cell-value-wrapper justify-center"}>
				{this.getExternalIcon()}
				{this.getCopyIcon()}
			</div>
		);
	}

	private getExternalIcon() {
		return (
			<div className={'circle-wrapper'}
				 onClick={(e) => this.showInNewTab(e)}>
				<IconSmall icon={Icon.ExternalLarge} variant={"white"}/>
			</div>
		);
	}

	private showInNewTab(evt: React.MouseEvent<HTMLDivElement>) {
		evt.stopPropagation();
		window.open(this.props.route, '_blank');
	}

	private getCopyIcon() {
		return (
			<div className={'circle-wrapper'}
				 onClick={(e) => this.copyLinkToClipboard(e)}>
				<IconSmall icon={Icon.Link} variant={"white"}/>
			</div>
		);
	};

	private copyLinkToClipboard(evt: React.MouseEvent<HTMLDivElement>) {
		evt.stopPropagation();
		TextUtils.copyToClipboard(`${window.location.host}${this.props.route}`);
		Toast.success("Link has been copied to clipboard", "Copy link")
	}
}